<template>
  <v-container class="pa-0">
    <v-row v-if="loading">
      <v-col
        cols="12"
        class="d-flex justify-center align-center"
        style="height: 100vh;"
      >
        <v-progress-circular
          indeterminate
          size="64"
          color="#2661FF"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="6">
        <h2 class="title text_color">
          Amazon Web Services Onboarding
        </h2>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-btn
          color="#2661FF"
          class="white--text rounded-lg"
          @click="toggleCreateDrawer(true)"
        >
          <v-icon>
            add
          </v-icon>
          <span>
            Crear cuenta de envío
          </span>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters class="mt-12">
          <v-col cols="12">
            <v-data-table
              :loading="sendEmailAccountsTable.loading"
              :items="sendEmailAccountsTable.items"
              :server-items-length="sendEmailAccountsTable.total"
              :items-per-page="sendEmailAccountsTable.pagination.itemsPerPage"
              :headers="sendEmailAccountsTable.headers"
              @update:options="sendEmailAccountsTable.pagination = $event"
              class="custom_card"
            >
              <template v-slot:item.createdAt="{ item }">
                <span>
                  {{ item.createdAt | moment('LL') }}
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon @click="openEditDrawer(item.id)">
                  <v-icon class="text_color">
                    edit_square
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <CreateSendEmailAccount v-if="isSendEmailAccountCreateDrawerOpen" />
    <EditSendEmailAccount v-if="isSendEmailAccountEditDrawerOpen" />
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import CreateSendEmailAccount from '@/components/Onboarding/AWS/CreateSendEmailAccount'
import EditSendEmailAccount from '@/components/Onboarding/AWS/EditSendEmailAccount'

export default {
  name: 'AmazonWebServices',
  components: {
    EditSendEmailAccount,
    CreateSendEmailAccount
  },
  data() {
    return {
      loading: false,
      sendEmailAccountsTable: {
        loading: false,
        items: [],
        total: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10
        },
        filters: {
          search: null
        },
        headers: [
          {
            text: 'Nombre',
            value: 'name',
            class: 'header_color'
          },
          {
            text: 'Región',
            value: 'awsRegion',
            class: 'header_color'
          },
          {
            text: 'Creado en',
            value: 'createdAt',
            class: 'header_color'
          },
          {
            text: 'Acciones',
            value: 'actions',
            class: 'header_color',
            sortable: false
          }
        ]
      }
    }
  },
  watch: {
    'aws.updateRequired': {
      async handler() {
        if (this.aws.updateRequired) {
          await this.fetchSendEmailAccounts()
          this.setUpdateRequired(false)
        }
      },
      deep: true
    },
    'sendEmailAccountsTable.pagination': {
      async handler() {
        await this.fetchSendEmailAccounts()
      },
      deep: true
    }
  },
  async created() {
    this.loading = true
    await this.fetchSendEmailAccounts()
    await this.fetchAWSRegions()
    this.loading = false
  },
  computed: {
    ...mapState({
      aws: state => state.onboarding.aws,
      isSendEmailAccountCreateDrawerOpen: state =>
        state.onboarding.aws.isSendEmailAccountCreateDrawerOpen,
      isSendEmailAccountEditDrawerOpen: state =>
        state.onboarding.aws.isSendEmailAccountEditDrawerOpen
    })
  },
  methods: {
    ...mapActions({
      fetchAWSRegions: 'onboarding/fetchAWSRegions',
      fetchSendEmailAccountsAction: 'onboarding/fetchSendEmailAccounts',
      fetchSendEmailAccountAction: 'onboarding/fetchSendEmailAccount'
    }),
    ...mapMutations({
      toggleSendEmailAccountCreateDrawer:
        'onboarding/toggleSendEmailAccountCreateDrawer',
      toggleSendEmailAccountEditDrawer:
        'onboarding/toggleSendEmailAccountEditDrawer',
      setUpdateRequired: 'onboarding/setUpdateRequired'
    }),
    async fetchSendEmailAccounts() {
      const { sendEmailAccountsTable } = this
      const { pagination, filters } = sendEmailAccountsTable

      const payload = {
        page: pagination.page,
        limit: pagination.itemsPerPage,
        search: filters.search
      }

      sendEmailAccountsTable.loading = true
      await this.fetchSendEmailAccountsAction(payload)

      sendEmailAccountsTable.items = this.aws.items
      sendEmailAccountsTable.total = parseInt(this.aws.total, 10)

      sendEmailAccountsTable.loading = false
    },
    toggleCreateDrawer(payload) {
      this.toggleSendEmailAccountCreateDrawer(payload)
    },
    async openEditDrawer(id) {
      await this.fetchSendEmailAccountAction(id)
      this.toggleSendEmailAccountEditDrawer(true)
    }
  }
}
</script>

<style>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}

.header_color {
  color: #2661ff !important;
}
</style>
